import type { AlpineComponent } from 'alpinejs'

export type SortDirection = 'asc' | 'desc'
export type SortEvent = CustomEvent<{ sortBy: string; sortDirection: SortDirection }>

type TableSortArgs = {
  sortBy: string
  sortDirection: SortDirection
}

type TableSortComponent = AlpineComponent<{
  sortBy: string
  sortDirection: SortDirection
  sortForm: HTMLFormElement
  sort: (attribute: string) => void
  sortIconClasses: (attribute: string) => Record<string, boolean>
}>

// Attach to an `<output>` element with a `for` attribute that points to a search form
export const tableSort = ({ sortBy, sortDirection }: TableSortArgs): TableSortComponent => ({
  sortBy,
  sortDirection,
  sortForm: undefined as unknown as HTMLFormElement,

  init() {
    const formId = (this.$root as HTMLOutputElement).htmlFor[0] as string
    this.sortForm = document.getElementById(formId) as HTMLFormElement
    !this.sortForm && console.error("Sort form can't be found")
  },

  sort(attribute) {
    const attrChanged = this.sortBy !== attribute
    const oppositeDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
    this.sortBy = attribute
    this.sortDirection = attrChanged ? 'asc' : oppositeDirection

    const sortEvent: SortEvent = new CustomEvent('sort', {
      bubbles: false,
      detail: { sortBy: this.sortBy, sortDirection: this.sortDirection },
    })
    this.sortForm.dispatchEvent(sortEvent)
  },

  sortIconClasses(attribute) {
    const active = this.sortBy === attribute

    return {
      iconify: true,
      'text-blue': active,
      'material-symbols--swap-vert': !active,
      'material-symbols--arrow-upward-alt': active && this.sortDirection === 'asc',
      'material-symbols--arrow-downward-alt': active && this.sortDirection === 'desc',
    }
  },
})
